/* eslint-disable no-empty-pattern */
import { Button, IconButton, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Close } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { allDataFilter, config_baseURL, isBaseURLAll, set_config_baseURL, } from '../../../api/utils';
import { AccessRoles } from '../../../constants/AccessLevel';
import { AccountSelector } from '../../commons/AccountSelector';
import { CustomMaterialTable } from '../../commons/CustomMaterialTable';
import { SideBarComponent } from '../../commons/SideBarComponent';
import { SnackbarComponent } from '../../commons/SnackbarComponent';
import { ContactListConfigurator } from '../ContactListConfigurator';
import { Title } from '../ContactListConfigurator/ContactListConfigurator.Styles';
import { ButtonWrapper, Content, TitleWrapper, Wrapper, } from './ContactListMainView.Styles';
import { ContactListTable } from './ContactListTable';
export var ContactListMainView = function (_a) {
    var tempDialerDefaults = _a.dialerDefaults, contactLists = _a.contactLists, selectedAccount = _a.selectedAccount, setAccount = _a.setAccount, getContactLists = _a.getContactLists, deleteContactListByID = _a.deleteContactListByID, updateContactListByID = _a.updateContactListByID, addContactList = _a.addContactList, accessLevel = _a.accessLevel, getDialerDefaults = _a.getDialerDefaults;
    var _b = useState(false), readOnly = _b[0], setReadOnly = _b[1];
    var _c = useState(false), openSidebar = _c[0], setOpenSidebar = _c[1];
    var _d = useState({}), selectedContactList = _d[0], setSelectedContactList = _d[1];
    var _e = useState(false), creating = _e[0], setCreating = _e[1];
    var _f = useState(contactLists), rowData = _f[0], setRowData = _f[1];
    var _g = useState(false), copied = _g[0], setCopied = _g[1];
    var _h = useState(false), openSnack = _h[0], setOpenSnack = _h[1];
    var _j = useState(false), openAlert = _j[0], setOpenAlert = _j[1];
    var _k = useState(''), snackMessage = _k[0], setSnackMessage = _k[1];
    var _l = useState(''), dataId = _l[0], setDataId = _l[1];
    var _m = useState('success'), severity = _m[0], setSeverity = _m[1];
    var _o = useState(false), openDependencyList = _o[0], setOpenDependencyList = _o[1];
    var _p = useState([]), dependents = _p[0], setDependents = _p[1];
    var _q = useState(tempDialerDefaults), dialerDefaults = _q[0], setGlobalDefaults = _q[1];
    var _r = useState(), accountURL = _r[0], setAccountURL = _r[1];
    useEffect(function () {
        if (Array.isArray(tempDialerDefaults)) {
            var temp = tempDialerDefaults.find(function (tg) { return tg.prjacc.url === config_baseURL(); });
            setGlobalDefaults(temp);
        }
        else {
            setGlobalDefaults(tempDialerDefaults);
        }
    }, [accountURL, tempDialerDefaults]);
    var handleOnRowDoubleClick = function (row, isEdit) {
        handleOpenSideBar();
        if (!isEdit) {
            setCopied(true);
            setCreating(true);
        }
        else if (isEdit) {
            setCreating(false);
            setCopied(false);
        }
        setSelectedContactList(row);
    };
    var handleDeleteClick = function (id) {
        deleteContactListByID(id, function (data) {
            handleDeleteCallback(data);
        });
    };
    var handleOpenSideBar = function (readOnly) {
        setOpenSidebar(true);
        if (!readOnly &&
            accessLevel !== AccessRoles.READ_ONLY &&
            accessLevel !== AccessRoles.ANALYST)
            localStorage.setItem('onEditMode', '1');
    };
    var handleOpenSnack = function () {
        setOpenSnack(true);
    };
    var handleCloseSnack = function (_event, reason) {
        setOpenSnack(false);
    };
    useEffect(function () {
        getContactLists();
        getDialerDefaults();
    }, [selectedAccount]);
    useEffect(function () {
        setRowData(contactLists);
    }, [contactLists]);
    var handleUpdateCallback = function (data) {
        var status = data.action.type;
        if (status === 'UPDATE_CONTACT_LIST_FULFILLED') {
            setSnackMessage('Contact List Updated!');
            setSeverity('success');
        }
        else if (data.errorMessage && data.errorMessage.includes('409')) {
            setSnackMessage('Data state is stale; refresh & retry!');
            setSeverity('error');
        }
        else {
            setSnackMessage('Contact List Update Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleAddCallback = function (data) {
        var status = data.action.type;
        if (status === 'ADD_CONTACT_LIST_FULFILLED') {
            setSnackMessage('Contact List Created!');
            setSeverity('success');
        }
        else {
            setSnackMessage('Contact List Creation Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleDeleteCallback = function (data) {
        var _a, _b, _c;
        var status = data.action.type;
        var response = data === null || data === void 0 ? void 0 : data.response;
        if (status === 'DELETE_CONTACT_LIST_FULFILLED') {
            setSnackMessage('Contact List Deleted!');
            setSeverity('success');
            setOpenSnack(true);
            setOpenDependencyList(false);
        }
        else if ((response === null || response === void 0 ? void 0 : response.status) !== 409) {
            setSnackMessage('Contact List Deletion Failed!');
            setSeverity('error');
            setOpenSnack(true);
        }
        else {
            setDependents((_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.dependents) === null || _b === void 0 ? void 0 : _b.dependents) === null || _c === void 0 ? void 0 : _c.campaigns);
            setOpenDependencyList(true);
        }
    };
    var handleDiscard = function () {
        setOpenSidebar(false);
        setReadOnly(false);
        setSelectedContactList({});
        localStorage.setItem('onEditMode', '0');
    };
    var alertReadOnly = function () {
        setSnackMessage('Access Denied');
        setSeverity('info');
        setOpenSnack(true);
    };
    var handleClose = function () {
        setOpenAlert(false);
    };
    var onHandleCopyToClipboard = function () {
        navigator.clipboard.writeText(JSON.stringify(dependents));
        setSnackMessage('Copied to Clipboard');
        setSeverity('success');
        setOpenSnack(true);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(Title, { variant: 'h6' }, "Contact Lists"),
            React.createElement(ButtonWrapper, null,
                React.createElement(AccountSelector, { initialValue: selectedAccount, onValueChange: function (data) { return setAccount(data); }, disabled: openSidebar }),
                React.createElement(Button, { variant: 'contained', disabled: openSidebar, color: 'primary', onClick: function () {
                        setCreating(true);
                        setSelectedContactList({});
                        handleOpenSideBar();
                    } }, accessLevel === AccessRoles.ANALYST ||
                    accessLevel === AccessRoles.READ_ONLY
                    ? 'See Form'
                    : 'New Contact List'))),
        React.createElement(SideBarComponent, { topOffSet: 47, open: openSidebar, readonly: readOnly ||
                accessLevel === AccessRoles.READ_ONLY ||
                accessLevel === AccessRoles.ANALYST, component: React.createElement(ContactListConfigurator, { readOnly: readOnly ||
                    accessLevel === AccessRoles.ANALYST ||
                    accessLevel === AccessRoles.READ_ONLY, onDiscardClick: function () { return handleDiscard(); }, contactLists: allDataFilter(contactLists), title: selectedContactList.name, creating: creating, copied: copied, selectedRow: selectedContactList, updateContactListByID: function (editedContactListConfig, id, initialContactListConfig) {
                    return updateContactListByID(editedContactListConfig, id, function (data) {
                        handleUpdateCallback(data);
                    }, initialContactListConfig);
                }, addContactList: function (contactList) {
                    return addContactList(contactList, function (data) {
                        handleAddCallback(data);
                    });
                }, handleOpenSnack: handleOpenSnack, dialerDefaults: dialerDefaults, onAlert: function (data, severity) {
                    setSnackMessage(data);
                    setSeverity(severity);
                    setOpenSnack(true);
                }, onAccountChange: function (url) { return setAccountURL(url); } }) },
            React.createElement(Content, null,
                React.createElement(ContactListTable, { onRowDoubleClick: function (_row, isEdit) {
                        if (accessLevel === AccessRoles.READ_ONLY ||
                            accessLevel === AccessRoles.ANALYST) {
                            alertReadOnly();
                        }
                        else {
                            handleOnRowDoubleClick(_row, isEdit);
                        }
                    }, viewRow: function (_row) {
                        setReadOnly(true);
                        handleOpenSideBar(true);
                        setSelectedContactList(_row);
                    }, deleteRow: function (_id) {
                        if (accessLevel === AccessRoles.READ_ONLY ||
                            accessLevel === AccessRoles.ANALYST) {
                            alertReadOnly();
                        }
                        else {
                            setOpenAlert(true);
                            setDataId(_id);
                            var aContact = contactLists.find(function (c) { return c.id === _id; });
                            if (isBaseURLAll() && aContact.prjacc) {
                                set_config_baseURL(aContact.prjacc.url);
                            }
                        }
                    }, rowData: rowData, openSidebar: openSidebar })),
            React.createElement(SnackbarComponent, { anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }, open: openSnack, autoHideDuration: 5000, onAlertClose: handleCloseSnack, alertMessage: snackMessage, severity: severity })),
        React.createElement(Dialog, { open: openAlert, onClose: function () { return handleClose(); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, "Delete Contact List"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Are you sure you want to delete this contact list configuration?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return handleClose(); }, color: 'primary' }, "Disagree"),
                React.createElement(Button, { onClick: function () {
                        handleClose();
                        handleDeleteClick(dataId);
                    }, color: 'primary', autoFocus: true }, "Agree"))),
        React.createElement(Dialog, { open: openDependencyList, onClose: function () { return setOpenDependencyList(false); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { disableTypography: true, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingRight: 5
                } },
                React.createElement(Typography, { variant: 'h6' }, "Cannot Delete - See Dependents"),
                React.createElement(IconButton, { "aria-label": 'close', onClick: function () { return setOpenDependencyList(false); } },
                    React.createElement(Close, null))),
            React.createElement(DialogContent, { dividers: true },
                React.createElement(DialogContentText, { id: 'alert-dialog-description' },
                    React.createElement(CustomMaterialTable, { rows: dependents, columns: [
                            { label: 'Campaign ID', value: 'campaignId' },
                            { label: 'Campaign Name', value: 'campaignName' },
                        ] }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return onHandleCopyToClipboard(); }, color: 'primary' }, "Copy To Clipboard")))));
};
ContactListMainView.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=ContactListMainView.js.map